module.exports = __webpack_public_path__ + "img/what-we-do-icon-4.bb1b519a.svg";